/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import React, { useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import { useDispatch, useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import FoodItem from "../Item";
import { fetchItemListData } from "./itemListSlice";
import { HTTP_STATUS } from "../../../config/config";
import { putItemList } from "./putItemListSlice";

const itemListStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: "calc((100vh - 49px - 25px - 28vh - 32px)/2)",
};

const itemMargin = {
  m: 0.5,
};

function ItemList() {
  const isFirstRender = useRef(true);
  const dispatch = useDispatch();
  const location = useLocation().pathname;
  const selectedCategory = location.split("/").pop();

  const itemList = useSelector((state) => state.itemList.data);
  const loading = useSelector((state) => state.itemList.loading);

  useEffect(() => {
    dispatch(fetchItemListData(selectedCategory));
  }, [selectedCategory]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    console.log("ItemList", itemList);
    const putPayload = {
      items: itemList.items,
      view: "VARIETY_VIEW",
    };
    dispatch(putItemList(putPayload));
  }, [itemList]);

  return (
    <>
      {loading === HTTP_STATUS.REJECTED && (
        <Grid item xs={12}>
          <Box sx={itemListStyle}>
            <Alert severity='error'>Error — unable to load items</Alert>
          </Box>
        </Grid>
      )}
      {loading === HTTP_STATUS.PENDING && (
        <Grid item xs={12}>
          <Box sx={itemListStyle}>
            <CircularProgress />
          </Box>
        </Grid>
      )}
      {loading === HTTP_STATUS.FULFILLED &&
        itemList.items.map((item) => (
          <Grid item xs={12} sm={4} md={3} key={item.item_id}>
            <Box sx={itemMargin}>
              <FoodItem item={item} />
            </Box>
          </Grid>
        ))}
    </>
  );
}

export default ItemList;
